import { tv } from '@change/ds-utils';

export const PostPreviewStyles = tv({
	base: 'outline-stroke-weaker bg-background-base flex flex-col overflow-hidden outline outline-offset-0',
	variants: {
		size: {
			xsmall: 'h-[174px] w-[80px] rounded-[10px] outline-[1.5px]',
			small: 'h-[218px] w-[100px] rounded-[10px] outline-[1.5px]',
			medium: 'h-[436px] w-[200px] rounded-[20px] outline-[3px]',
			large: 'h-[436px] w-[200px] rounded-3xl outline-[4px]',
		},
		disabled: {
			true: 'opacity-50',
			false: 'opacity-100',
		},
	},
});
